import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import Engine from '@milestoneslabs/milestones-js-engine';

export const UUIDS = {
    REAL_ESTATE: 'b216bfe4-ad22-45b2-b415-40ba15a942b6',
    MORTGAGE: '109a954f-8289-4018-8436-afad7a9da7b7',
    TITLE_AND_ESCROW: 'b7fe18ee-cd47-42d5-96c2-1eefbe51f90e',
    HOME_SERVICES: 'bfd038fd-ea8d-43e0-9f9c-1fff23de50b9',
    HOME_WARRANTY: '0823fa7b-da7b-44aa-b581-48d609157d64',
    INSURANCE: 'aeee6e9e-06d6-451e-8a49-32c763c409d5',
    INSPECTIONS: '8a2e9cb0-536e-4413-b417-a4d7b2b76745',
    HOME_BUILDERS: 'bff900d9-7b4e-4147-b541-7954c70336af',
};

class IndustryAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'industry';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'industries';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'slug',
            'name',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return [];
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            slug: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            name: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
        };
    }

    apiPaths () {
        return {
            'occupationsSearch': Engine.apiUrl(this.appResourceApiPrefix()) + '/occupations/search',
            ...super.apiPaths(),
        }
    }

    async occupationsSearch(ownerUserUuid, organizationUuid) {
        return await new Promise((resolve, reject) => {
            Engine.xhrLib.post(this.apiPaths().occupationsSearch).then(res => {
                resolve(res?.data?.data);
            });
        });
    }

}

export default IndustryAppResource;
